import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/audio/item-obtain.ogg'
import _imports_1 from '@/assets/audio/item-obtain.mp3'
import _imports_2 from '@/assets/audio/close-overlay.ogg'
import _imports_3 from '@/assets/audio/close-overlay.mp3'
import _imports_4 from '@/assets/images/star.svg'


const _withScopeId = n => (_pushScopeId("data-v-3ef0243a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("audio", { autoplay: "" }, [
  /*#__PURE__*/_createElementVNode("source", {
    src: _imports_0,
    type: "audio/ogg"
  }),
  /*#__PURE__*/_createElementVNode("source", {
    src: _imports_1,
    type: "audio/mp3"
  })
], -1))
const _hoisted_2 = {
  ref: "audioExitOverlay",
  preload: "auto"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" ] ")
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("source", {
  src: _imports_2,
  type: "audio/ogg"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("source", {
  src: _imports_3,
  type: "audio/mp3"
}, null, -1))
const _hoisted_6 = [
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "obtained" }, "Obtained", -1))
const _hoisted_8 = {
  id: "item-obtain-overlay-center-box",
  class: "center-box"
}
const _hoisted_9 = { class: "description" }
const _hoisted_10 = {
  id: "item-obtain-overlay-items-box",
  class: "items-box"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "star-box" }
const _hoisted_14 = { class: "quantity-text" }
const _hoisted_15 = { class: "item-name" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "dim" }, "Press anywhere in the blank area to continue", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_item_description_overlay = _resolveComponent("item-description-overlay")!
  const _directive_dragscroll = _resolveDirective("dragscroll")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("audio", _hoisted_2, _hoisted_6, 512),
    (_ctx.activeItem)
      ? (_openBlock(), _createBlock(_component_item_description_overlay, {
          key: 0,
          item: _ctx.activeItem,
          onExit: _cache[0] || (_cache[0] = ($event: any) => (_ctx.activeItemId = ''))
        }, null, 8, ["item"]))
      : _createCommentVNode("", true),
    _createVNode(_Transition, {
      name: "zoom-fade",
      onAfterLeave: _ctx.exit
    }, {
      default: _withCtx(() => [
        (_ctx.active)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              id: "item-obtain-overlay-bg",
              class: "main",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.exitOutsideCheck && _ctx.exitOutsideCheck(...args)))
            }, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.description), 1),
                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_10, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (i, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "box-for-one-item"
                    }, [
                      _createElementVNode("div", {
                        class: "item-box-graphics",
                        onClick: ($event: any) => (_ctx.activeItemId = i.item.id)
                      }, [
                        _createElementVNode("div", {
                          class: _normalizeClass([
                  [0, 'gray', 'green', 'blue', 'purple', 'orange'][
                    i.item.rarity
                  ],
                  'item-pic-box',
                ])
                        }, [
                          _createElementVNode("img", {
                            src: require(`@/assets/images/${i.item.id}.webp`),
                            class: "icon-img"
                          }, null, 8, _hoisted_12)
                        ], 2),
                        _createElementVNode("div", _hoisted_13, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(i.item.rarity, (i) => {
                            return (_openBlock(), _createElementBlock("img", {
                              key: i,
                              class: "star-img",
                              src: _imports_4
                            }))
                          }), 128))
                        ]),
                        _createElementVNode("p", _hoisted_14, _toDisplayString(i.quantity), 1)
                      ], 8, _hoisted_11),
                      _createElementVNode("p", _hoisted_15, _toDisplayString(i.item.name), 1)
                    ]))
                  }), 128))
                ])), [
                  [
                    _directive_dragscroll,
                    void 0,
                    void 0,
                    { x: true }
                  ]
                ])
              ]),
              _hoisted_16
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["onAfterLeave"])
  ], 64))
}